// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.continue_screen {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
}

.continue_screen-container {
  text-align: center;
}

.continue_screen-container button {
  margin: 0 10px;
}

.initialization-container,
.initialization-error-container {
  position: relative;
  background-color: black;
  height: 100%;
  width: 100%;
}

.initialization-container .label,
.initialization-error-container .label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 28px;
  text-transform: uppercase;
  font-weight: bold;
}

.initialization-container .label,
.image-container-alert {
  color: white;
}

.initialization-error-container .label {
  color: red;
}

.shooting-screen-container {
  height: 100%;
  background-color: black;
  position: relative;
}

.initialization-container button,
.initialization-error-container button,
.shooting-screen-container button {
  position: absolute;
  z-index: 999;
}

.shooting-screen-container .btn-cancel,
.initialization-container .btn-cancel,
.initialization-error-container .btn-cancel {
  top: 10px;
  right: 10px;
}

.shooting-screen-container .btn-enroll {
  top: 10px;
  left: 10px;
}

.shooting-screen-container .image-container {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  overflow: hidden;
}

.shooting-screen-container .silhouette {
  left: 0;
  bottom: 0;
  height: 82%;
  /* значение высоты, при котором уровень переносицы находится на значении 45% от верхнего края*/
  width: 100%;
  z-index: 200;
  position: absolute;
}

.shooting-screen-container .fit-to-height {
  height: 100%;
}

.shooting-screen-container .fit-to-width {
  width: 100%;
}

.shooting-screen-container .eye-position-marker {
  position: absolute;
  margin: -15px;
}

.shooting-screen-container .eye-position-parameters {
  position: absolute;
  margin-top: 15px;
  margin-left: 10px;
  font-weight: bold;
  font-size: 13px;
  color: red;
}

.confirmation-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  padding: 10px;
  flex: none;
  text-align: center;
}

.header .label {
  font-size: 24px;
  font-weight: bold;
}

.photo-list {
  width: 100%;
  justify-content: center;
  display: flex;
}

.photo-list .cropped-image {
  margin: 10px;
  width: 30%;
  border: black 1px solid;
}

.command-line {
  display: flex;
  width: 100%;
  justify-content: center;
}

.command-line button {
  margin: 10px;
  width: 170px;
}

.MRZline {
  position: absolute;
  width: 100%;
  border-top: 1px solid #41C5E3;
  border-bottom: 1px solid #41C5E3;
  z-index: 10;
  background-size: cover;
}

.shade {
  display: flex;
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
}

.shooting-screen-container {
  width: 100%;
}

.shooting-screen-container .image-container {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  overflow: hidden;
}

.cam_left__collumn,
.cam_right__collumn {
  background: #f8f8fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  padding: 10px;
  align-items: center;
  z-index: 20;
}

.image-container {
  box-sizing: border-box;
  width: 100%;
  background: url('pass_background.673d187cdc0b6aff.png');
  background-size: cover;
}

.btn-cancel {
  width: 55px;
  height: 55px;
  background: #e4e8eb;
  border-radius: 7px;
}

.btn-cancel-init {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.btn-cancel-init button {
  margin: 10px;
}

.light_icon {
  color: #44494e;
}

.light_icon__active {
  color: #448aff;
}

.rotate {
  transform: rotate(180deg);
  transition: 0.75s;
}

.derotate {
  transform: rotate(0deg);
  transition: 0.75s;
}

.image-container-alert {
  align-items: center;
  display: flex;
  height: 100%;
  background: black;
  justify-content: center;
  z-index: 10000000000000000;
  width: 100%;
}

.image-container-alert .label {
  font-size: 28px;
  font-weight: bold;
  text-transform: uppercase;
}

.mask_strip {
  width: 100%;
  position: absolute;
  height: 100%;
}

.disable_rotate {
  color: #e4e8eb !important;
}

.stationary-mode-container {
  position: absolute;
  top: 50%;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/scan-mrz/pass.scan.mrz.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,cAAA;AAEJ;;AACA;;EAEI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAEJ;;AACA;;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAEJ;;AACA;;EAEI,YAAA;AAEJ;;AACA;EACI,UAAA;AAEJ;;AACA;EACI,YAAA;EACA,uBAAA;EACA,kBAAA;AAEJ;;AACA;;;EAGI,kBAAA;EACA,YAAA;AAEJ;;AACA;;;EAGI,SAAA;EACA,WAAA;AAEJ;;AACA;EACI,SAAA;EACA,UAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,OAAA;EACA,SAAA;EACA,WAAA;EACA,8FAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,kBAAA;EACA,aAAA;AAEJ;;AACA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAEJ;;AACA;EACI,WAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;AAEJ;;AACA;EACI,eAAA;EACA,iBAAA;AAEJ;;AACA;EACI,WAAA;EACA,uBAAA;EACA,aAAA;AAEJ;;AACA;EACI,YAAA;EACA,UAAA;EACA,uBAAA;AAEJ;;AACA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;AAEJ;;AACA;EACI,YAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,gCAAA;EACA,WAAA;EACA,sBAAA;AAEJ;;AACA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;;AACA;;EAEI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAEJ;;AACA;EACI,sBAAA;EACA,WAAA;EACA,uDAAA;EACA,sBAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,cAAA;AAEJ;;AACA;EACI,cAAA;AAEJ;;AACA;EACI,yBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,uBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,WAAA;AAEJ;;AACA;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AAEJ;;AACA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AAEJ","sourcesContent":[".continue_screen {\n    width: 100%;\n    background: #fff;\n    display: flex;\n    justify-content: center;\n}\n\n.continue_screen-container {\n    text-align: center;\n}\n\n.continue_screen-container button {\n    margin: 0 10px;\n}\n\n.initialization-container,\n.initialization-error-container {\n    position: relative;\n    background-color: black;\n    height: 100%;\n    width: 100%;\n}\n\n.initialization-container .label,\n.initialization-error-container .label {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    font-size: 28px;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n.initialization-container .label,\n.image-container-alert {\n    color: white;\n}\n\n.initialization-error-container .label {\n    color: red;\n}\n\n.shooting-screen-container {\n    height: 100%;\n    background-color: black;\n    position: relative;\n}\n\n.initialization-container button,\n.initialization-error-container button,\n.shooting-screen-container button {\n    position: absolute;\n    z-index: 999;\n}\n\n.shooting-screen-container .btn-cancel,\n.initialization-container .btn-cancel,\n.initialization-error-container .btn-cancel {\n    top: 10px;\n    right: 10px;\n}\n\n.shooting-screen-container .btn-enroll {\n    top: 10px;\n    left: 10px;\n}\n\n.shooting-screen-container .image-container {\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n    position: absolute;\n    overflow: hidden;\n}\n\n.shooting-screen-container .silhouette {\n    left: 0;\n    bottom: 0;\n    height: 82%;\n    /* значение высоты, при котором уровень переносицы находится на значении 45% от верхнего края*/\n    width: 100%;\n    z-index: 200;\n    position: absolute;\n}\n\n.shooting-screen-container .fit-to-height {\n    height: 100%;\n}\n\n.shooting-screen-container .fit-to-width {\n    width: 100%;\n}\n\n.shooting-screen-container .eye-position-marker {\n    position: absolute;\n    margin: -15px;\n}\n\n.shooting-screen-container .eye-position-parameters {\n    position: absolute;\n    margin-top: 15px;\n    margin-left: 10px;\n    font-weight: bold;\n    font-size: 13px;\n    color: red;\n}\n\n.confirmation-container {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.header {\n    width: 100%;\n    padding: 10px;\n    flex: none;\n    text-align: center;\n}\n\n.header .label {\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.photo-list {\n    width: 100%;\n    justify-content: center;\n    display: flex;\n}\n\n.photo-list .cropped-image {\n    margin: 10px;\n    width: 30%;\n    border: black 1px solid;\n}\n\n.command-line {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n}\n\n.command-line button {\n    margin: 10px;\n    width: 170px;\n}\n\n.MRZline {\n    position: absolute;\n    width: 100%;\n    border-top: 1px solid #41C5E3;\n    border-bottom: 1px solid #41C5E3;\n    z-index: 10;\n    background-size: cover;\n}\n\n.shade {\n    display: flex;\n    max-height: 100vh;\n    max-width: 100vw;\n    height: 100vh;\n    width: 100vw;\n    box-sizing: border-box;\n}\n\n.shooting-screen-container {\n    width: 100%;\n}\n\n.shooting-screen-container .image-container {\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n    position: absolute;\n    overflow: hidden;\n}\n\n.cam_left__collumn,\n.cam_right__collumn {\n    background: #f8f8fa;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 80px;\n    padding: 10px;\n    align-items: center;\n    z-index: 20;\n}\n\n.image-container {\n    box-sizing: border-box;\n    width: 100%;\n    background: url(../../../assets/images/pass_background.png);\n    background-size: cover;\n}\n\n.btn-cancel {\n    width: 55px;\n    height: 55px;\n    background: #e4e8eb;\n    border-radius: 7px;\n}\n\n.btn-cancel-init {\n    width: fit-content;\n    height: fit-content;\n}\n\n.btn-cancel-init button {\n    margin: 10px;\n}\n\n.light_icon {\n    color: #44494e;\n}\n\n.light_icon__active {\n    color: #448aff;\n}\n\n.rotate {\n    transform: rotate(180deg);\n    transition: 0.75s;\n}\n\n.derotate {\n    transform: rotate(0deg);\n    transition: 0.75s;\n}\n\n.image-container-alert {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    background: black;\n    justify-content: center;\n    z-index: 10000000000000000;\n    width: 100%;\n}\n\n.image-container-alert .label {\n    font-size: 28px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.mask_strip {\n    width: 100%;\n    position: absolute;\n    height: 100%;\n}\n\n.disable_rotate {\n    color: #e4e8eb !important;\n}\n\n.stationary-mode-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
